
import React, { useState, useEffect } from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Area, AreaChart } from 'recharts';
import { Calendar, Eye, TrendingUp, Package, ShoppingCart, Users, FileText, ArrowUp, ArrowDown, Filter, RefreshCw, Bell, Settings, Zap, Target, Activity, BarChart3, PieChart as PieChartIcon, Search, Download, MoreVertical, ChevronLeft, ChevronRight } from 'lucide-react';
import logo from "../assets/infraLogo.jpg";
import { 
  Building2, 
  CalendarDays,
  ChevronDown,
  Clock,
} from 'lucide-react';

const Dashboard = () => {
  const [selectedBranch, setSelectedBranch] = useState('all');
  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentActionIndex, setCurrentActionIndex] = useState(0);

  const [startDate, setStartDate] = useState('2022-04-01');
  const [endDate, setEndDate] = useState('2025-07-28');
  const [activeDropdown, setActiveDropdown] = useState(null);
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Enhanced sample data
  const purchaseSummaryData = [
    { month: 'Mar', 'HEAD-OFFICE': 5000, 'HILARA': 3000, total: 8000 },
    { month: 'Apr', 'HEAD-OFFICE': 8000, 'HILARA': 4500, total: 12500 },
    { month: 'May', 'HEAD-OFFICE': 12000, 'HILARA': 7000, total: 19000 },
    { month: 'Jun', 'HEAD-OFFICE': 18000, 'HILARA': 9000, total: 27000 },
    { month: 'Jul', 'HEAD-OFFICE': 25000, 'HILARA': 13000, total: 38000 },
    { month: 'Aug', 'HEAD-OFFICE': 32000, 'HILARA': 16000, total: 48000 },
  ];

  const topPurchasedData = [
    { name: 'HEAD-OFFICE', value: 275000, growth: 12.5, percentage: 65.5 },
    { name: 'HILARA', value: 145000, growth: 8.3, percentage: 34.5 },
  ];

  const mostPurchasedItems = [
    { item: 'VALVOLINE 5W', value: 25000, trend: 'up', growth: '+15.2%' },
    { item: 'HSD CYLINDER', value: 8000, trend: 'up', growth: '+8.7%' },
    { item: 'ENGINE OIL', value: 6500, trend: 'down', growth: '-3.2%' },
    { item: 'BRAKE FLUID', value: 4200, trend: 'up', growth: '+12.1%' },
    { item: 'COOLANT', value: 3800, trend: 'down', growth: '-5.8%' },
    { item: 'TRANSMISSION', value: 3200, trend: 'up', growth: '+9.4%' },
    { item: 'WINDSHIELD', value: 2500, trend: 'up', growth: '+6.3%' },
  ];

  const pieData = [
    { name: 'Spares', value: 65, color: '#6366F1', description: 'Vehicle spare parts' },
    { name: 'Tools', value: 25, color: '#F59E0B', description: 'Maintenance tools' },
    { name: 'Others', value: 10, color: '#10B981', description: 'Miscellaneous items' }
  ];
 const branches = [
    { value: 'all', label: 'All Branches', count: '2 locations' },
    { value: 'head-office', label: 'HEAD-OFFICE', count: 'Main branch' },
    { value: 'hilara', label: 'HILARA', count: 'Sub branch' }
  ];
  const statsCards = [
    { 
      title: 'Total Revenue', 
      value: '₹4,20,000', 
      change: '+12.5%', 
      trend: 'up', 
      color: 'blue', 
      icon: TrendingUp,
      description: 'vs last month',
      target: '₹5,00,000'
    },
    { 
      title: 'Orders This Month', 
      value: '284', 
      change: '+8.2%', 
      trend: 'up', 
      color: 'green', 
      icon: ShoppingCart,
      description: 'active orders',
      target: '300'
    },
    { 
      title: 'Pending Orders', 
      value: '15', 
      change: '-15.3%', 
      trend: 'down', 
      color: 'orange', 
      icon: FileText,
      description: 'awaiting approval',
      target: '10'
    },
    { 
      title: 'Active Branches', 
      value: '2', 
      change: '0%', 
      trend: 'neutral', 
      color: 'purple', 
      icon: Package,
      description: 'operational sites',
      target: '3'
    },
  ];

  const pendingItems = [
    { 
      type: 'GRN Pending', 
      count: 8, 
      color: 'from-amber-500 to-orange-600', 
      bgColor: 'from-amber-50 via-orange-50 to-amber-100', 
      borderColor: 'border-amber-300',
      priority: 'high',
      dueDate: '2 hours',
      department: 'Procurement'
    },
    { 
      type: 'Purchase Order Pending', 
      count: 3, 
      color: 'from-blue-500 to-indigo-600', 
      bgColor: 'from-blue-50 via-indigo-50 to-blue-100', 
      borderColor: 'border-blue-300',
      priority: 'medium',
      dueDate: '1 day',
      department: 'Operations'
    },
    { 
      type: 'Rate Comparison Approval', 
      count: 3, 
      color: 'from-emerald-500 to-green-600', 
      bgColor: 'from-emerald-50 via-green-50 to-emerald-100', 
      borderColor: 'border-emerald-300',
      priority: 'medium',
      dueDate: '3 days',
      department: 'Finance'
    },
    { 
      type: 'Purchase Request Approval', 
      count: 1, 
      color: 'from-purple-500 to-pink-600', 
      bgColor: 'from-purple-50 via-pink-50 to-purple-100', 
      borderColor: 'border-purple-300',
      priority: 'low',
      dueDate: '1 week',
      department: 'Admin'
    },
  ];

  const vehicles = [
    { 
      id: 'vehicle1', 
      name: 'Truck - TN01AB1234', 
      status: 'Active', 
      maintenance: '2 days ago', 
      fuel: '85%',
      location: 'Chennai Hub',
      driver: 'Rajesh Kumar'
    },
    { 
      id: 'vehicle2', 
      name: 'Van - TN02CD5678', 
      status: 'Maintenance', 
      maintenance: 'Today', 
      fuel: '42%',
      location: 'Service Center',
      driver: 'Unassigned'
    },
    { 
      id: 'vehicle3', 
      name: 'Bus - TN03EF9012', 
      status: 'Active', 
      maintenance: '1 week ago', 
      fuel: '78%',
      location: 'Madurai Branch',
      driver: 'Suresh Babu'
    },
  ];

  const DropdownButton = ({ icon: Icon, label, isActive, onClick, children, className = "" }) => (
    <div className="relative">
      <button
        onClick={onClick}
        className={`group relative p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 ${className}`}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 to-indigo-400/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
        <div className="relative flex items-center gap-2">
          <Icon className="w-5 h-5 text-gray-700 group-hover:text-blue-600 transition-colors" />
          {isActive && <ChevronDown className="w-4 h-4 text-gray-500 transition-transform duration-300" style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)' }} />}
          <span className="sr-only">{label}</span>
        </div>
      </button>
      
      {isActive && (
        <div className="absolute top-full mt-2 right-0 z-50 min-w-[280px] bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/50 p-2 animate-in slide-in-from-top-5 duration-300">
          <div className="absolute -top-2 right-6 w-4 h-4 bg-white/95 border-l border-t border-white/50 rotate-45"></div>
          {children}
        </div>
      )}
    </div>
  );
  
  const nextAction = () => {
    setCurrentActionIndex((prev) => (prev + 1) % pendingItems.length);
  };

  const prevAction = () => {
    setCurrentActionIndex((prev) => (prev - 1 + pendingItems.length) % pendingItems.length);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white/95 backdrop-blur-xl p-6 rounded-2xl shadow-2xl border border-gray-200/50 min-w-[200px]">
          <p className="font-black text-gray-800 mb-4 text-lg border-b border-gray-200 pb-2">{`${label}`}</p>
          {payload.map((pld, index) => (
            <div key={index} className="flex items-center justify-between gap-6 mb-3">
              <div className="flex items-center gap-3">
                <div className="w-4 h-4 rounded-full shadow-sm border-2 border-white" style={{ backgroundColor: pld.color }}></div>
                <span className="text-sm font-bold text-gray-700">{pld.dataKey}</span>
              </div>
              <span className="font-black text-gray-900 text-lg">₹{pld.value?.toLocaleString()}</span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour12: true, 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 via-indigo-50 to-purple-100 p-4 lg:p-8">
         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-6 relative overflow-hidden">
      {/* Enhanced Floating Background Effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/30 to-indigo-200/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-3/4 right-1/4 w-[32rem] h-[32rem] bg-gradient-to-r from-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1000ms' }}></div>
        <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-gradient-to-r from-indigo-200/40 to-purple-200/40 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '500ms' }}></div>
        <div className="absolute top-1/6 right-1/6 w-64 h-64 bg-gradient-to-r from-emerald-200/25 to-teal-200/25 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '750ms' }}></div>
      </div>

      {/* Premium Header with Live Clock and Logo */}
      <div className="relative bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-8 mb-12 border border-white/50 hover:shadow-3xl transition-all duration-700">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-indigo-500/5 to-purple-500/5 rounded-3xl"></div>
        
        {/* Live Status and Clock */}
        <div className="absolute top-6 right-6 flex items-center gap-4 text-sm font-medium text-gray-600">
          <div className="flex items-center gap-2 bg-white/70 backdrop-blur-xl rounded-full px-4 py-2 border border-white/40">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="font-semibold">Live</span>
          </div>
          <div className="bg-white/70 backdrop-blur-xl rounded-full px-4 py-2 border border-white/40">
            <div className="font-mono text-blue-700 font-bold text-base">
              {formatTime(currentTime)}
            </div>
          </div>
        </div>
        
        <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            {/* Logo and Company Name Section */}
            <div className="flex items-center gap-6">
              {/* Enhanced Company Logo */}
              <div className="relative group">
                <div className="w-24 h-24 lg:w-28 lg:h-28 rounded-3xl overflow-hidden shadow-2xl border-4 border-white/60 group-hover:scale-105 transition-all duration-500">
                  <div className="w-full h-full bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-700 flex items-center justify-center">
                     <img 
                    src={logo} 
                    alt="Infraconsoft Logo" 
                    className="w-full h-full object-cover object-center"
                    onError={(e) => {
                      // Fallback if image doesn't load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-blue-400/40 to-indigo-400/40 rounded-3xl blur-xl animate-pulse group-hover:blur-2xl transition-all duration-500"></div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-lg">
                  <Zap className="w-3 h-3 text-white" />
                </div>
              </div>
              
              <div>
                <h1 className="text-5xl lg:text-7xl font-black bg-gradient-to-r from-gray-800 via-blue-800 to-purple-800 bg-clip-text text-transparent mb-4 leading-tight">
                  Infraconsoft
                </h1>
                <p className="text-gray-600 text-xl lg:text-2xl font-semibold mb-3">Real-time business intelligence & performance insights</p>
                <div className="flex items-center gap-6">
                  <div className="flex items-center gap-2 text-sm text-gray-500 bg-white/50 rounded-full px-3 py-1">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    <span className="font-medium">Connected to 2 branches</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-500 bg-white/50 rounded-full px-3 py-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                    <span className="font-medium">All systems operational</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Enhanced Control Panel */}
          <div className="flex flex-wrap items-center gap-3">
            {/* Branch Selection Dropdown */}
            <DropdownButton
              icon={Building2}
              label="Branch Selection"
              isActive={activeDropdown === 'branch'}
              onClick={() => setActiveDropdown(activeDropdown === 'branch' ? null : 'branch')}
            >
              <div className="p-3">
                <div className="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                  <Building2 className="w-4 h-4" />
                  Select Branch Location
                </div>
                {branches.map((branch) => (
                  <button
                    key={branch.value}
                    onClick={() => {
                      setSelectedBranch(branch.value);
                      setActiveDropdown(null);
                    }}
                    className={`w-full text-left p-3 rounded-2xl mb-2 transition-all duration-200 flex items-center justify-between group hover:bg-blue-50 ${
                      selectedBranch === branch.value ? 'bg-blue-100 border-2 border-blue-300' : 'bg-gray-50 hover:bg-blue-50'
                    }`}
                  >
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-blue-700">{branch.label}</div>
                      <div className="text-xs text-gray-500">{branch.count}</div>
                    </div>
                    {selectedBranch === branch.value && (
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    )}
                  </button>
                ))}
              </div>
            </DropdownButton>

            {/* Date Range Selection */}
            <DropdownButton
              icon={CalendarDays}
              label="Date Range"
              isActive={activeDropdown === 'date'}
              onClick={() => setActiveDropdown(activeDropdown === 'date' ? null : 'date')}
            >
              <div className="p-4">
                <div className="text-sm font-bold text-gray-700 mb-4 flex items-center gap-2">
                  <CalendarDays className="w-4 h-4" />
                  Select Date Range
                </div>
                <div className="space-y-4">
                  <div className="bg-gray-50 rounded-2xl p-4">
                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 block">Start Date</label>
                    <input 
                      type="date" 
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full border-2 border-gray-200 rounded-xl px-3 py-2 font-semibold text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                    />
                  </div>
                  <div className="bg-gray-50 rounded-2xl p-4">
                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 block">End Date</label>
                    <input 
                      type="date" 
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full border-2 border-gray-200 rounded-xl px-3 py-2 font-semibold text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                    />
                  </div>
                  <button 
                    onClick={() => setActiveDropdown(null)}
                    className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl py-3 font-bold hover:from-blue-600 hover:to-indigo-700 transition-all duration-300"
                  >
                    Apply Date Range
                  </button>
                </div>
              </div>
            </DropdownButton>

            {/* View/Analyze Button */}
            <DropdownButton
              icon={BarChart3}
              label="View Options"
              isActive={activeDropdown === 'view'}
              onClick={() => setActiveDropdown(activeDropdown === 'view' ? null : 'view')}
            >
              <div className="p-3">
                <div className="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                  <BarChart3 className="w-4 h-4" />
                  Analysis Options
                </div>
                <div className="space-y-2">
                  <button className="w-full text-left p-3 rounded-2xl bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 transition-all duration-200 flex items-center gap-3 group">
                    <Eye className="w-4 h-4 text-blue-600" />
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-blue-700">Quick Analysis</div>
                      <div className="text-xs text-gray-500">Generate instant insights</div>
                    </div>
                  </button>
                  <button className="w-full text-left p-3 rounded-2xl bg-gray-50 hover:bg-blue-50 transition-all duration-200 flex items-center gap-3 group">
                    <BarChart3 className="w-4 h-4 text-gray-600 group-hover:text-blue-600" />
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-blue-700">Detailed Report</div>
                      <div className="text-xs text-gray-500">Comprehensive analysis</div>
                    </div>
                  </button>
                </div>
              </div>
            </DropdownButton>

            {/* Inventory Navigation */}
            <DropdownButton
              icon={Package}
              label="Inventory"
              isActive={activeDropdown === 'inventory'}
              onClick={() => setActiveDropdown(activeDropdown === 'inventory' ? null : 'inventory')}
              className="bg-gradient-to-r from-emerald-500/10 to-green-500/10 border-emerald-200"
            >
              <div className="p-3">
                <div className="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                  <Package className="w-4 h-4" />
                  Inventory Management
                </div>
                <div className="space-y-2">
                  <button className="w-full text-left p-3 rounded-2xl bg-gradient-to-r from-emerald-50 to-green-50 hover:from-emerald-100 hover:to-green-100 transition-all duration-200 flex items-center gap-3 group">
                    <Package className="w-4 h-4 text-emerald-600" />
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-emerald-700">Current Stock</div>
                      <div className="text-xs text-gray-500">View inventory levels</div>
                    </div>
                  </button>
                  <button className="w-full text-left p-3 rounded-2xl bg-gray-50 hover:bg-emerald-50 transition-all duration-200 flex items-center gap-3 group">
                    <BarChart3 className="w-4 h-4 text-gray-600 group-hover:text-emerald-600" />
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-emerald-700">Stock Movement</div>
                      <div className="text-xs text-gray-500">Track inventory changes</div>
                    </div>
                  </button>
                  <button className="w-full text-left p-3 rounded-2xl bg-gray-50 hover:bg-emerald-50 transition-all duration-200 flex items-center gap-3 group">
                    <Clock className="w-4 h-4 text-gray-600 group-hover:text-emerald-600" />
                    <div>
                      <div className="font-semibold text-gray-800 group-hover:text-emerald-700">Reorder Alerts</div>
                      <div className="text-xs text-gray-500">Low stock notifications</div>
                    </div>
                  </button>
                </div>
              </div>
            </DropdownButton>

            {/* Action Buttons */}
            <div className="flex items-center gap-2 pl-2 border-l-2 border-white/30">
              <button className="p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 group">
                <Search className="w-5 h-5 text-gray-700 group-hover:text-blue-600 transition-colors" />
              </button>

              <button className="p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 group">
                <Download className="w-5 h-5 text-gray-700 group-hover:text-green-600 transition-colors" />
              </button>

              <button className="p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 group">
                <RefreshCw className="w-5 h-5 text-gray-700 group-hover:text-blue-600 transition-colors" />
              </button>

              <button className="p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 relative border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 group">
                <Bell className="w-5 h-5 text-gray-700 group-hover:text-red-600 transition-colors" />
                <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 rounded-full animate-pulse flex items-center justify-center shadow-lg">
                  <span className="text-xs font-bold text-white">3</span>
                </div>
              </button>

              <button className="p-4 bg-white/90 backdrop-blur-xl hover:bg-white rounded-2xl transition-all duration-300 border-2 border-white/60 hover:shadow-xl hover:-translate-y-1 group">
                <Settings className="w-5 h-5 text-gray-700 group-hover:text-purple-600 transition-colors" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Click outside to close dropdowns */}
      {activeDropdown && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setActiveDropdown(null)}
        ></div>
      )}
    </div>

      {/* Enhanced Stats Cards with Progress Bars */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 mb-14">
        {statsCards.map((stat, index) => {
          const IconComponent = stat.icon;
          const progressPercentage = (parseInt(stat.value.replace(/[^\d]/g, '')) / parseInt(stat.target.replace(/[^\d]/g, ''))) * 100;
          
          return (
            <div key={index} className="group relative bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-8 border border-white/50 hover:shadow-3xl transition-all duration-500 hover:-translate-y-3 hover:rotate-1">
              <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute top-4 right-4">
                <button className="p-1 rounded-lg hover:bg-gray-100 transition-colors opacity-0 group-hover:opacity-100">
                  <MoreVertical className="w-4 h-4 text-gray-400" />
                </button>
              </div>
              
              <div className="relative">
                <div className="flex items-center justify-between mb-6">
                  <div className={`p-4 rounded-2xl bg-gradient-to-br shadow-xl ${
                    stat.color === 'blue' ? 'from-blue-500 to-blue-600' :
                    stat.color === 'green' ? 'from-emerald-500 to-green-600' :
                    stat.color === 'orange' ? 'from-amber-500 to-orange-600' :
                    'from-purple-500 to-pink-600'
                  }`}>
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                  <div className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-black ${
                    stat.trend === 'up' ? 'text-emerald-700 bg-emerald-100 border border-emerald-200' : 
                    stat.trend === 'down' ? 'text-red-700 bg-red-100 border border-red-200' : 
                    'text-gray-700 bg-gray-100 border border-gray-200'
                  }`}>
                    {stat.trend === 'up' && <ArrowUp className="w-4 h-4" />}
                    {stat.trend === 'down' && <ArrowDown className="w-4 h-4" />}
                    {stat.change}
                  </div>
                </div>
                
                <h3 className="text-sm font-black text-gray-600 mb-3 uppercase tracking-wider">{stat.title}</h3>
                <p className="text-4xl font-black text-gray-900 group-hover:scale-105 transition-transform duration-300 mb-2">{stat.value}</p>
                <p className="text-xs text-gray-500 font-medium mb-4">{stat.description}</p>
                
                {/* Progress Bar */}
                <div className="space-y-2">
                  <div className="flex justify-between text-xs font-medium text-gray-600">
                    <span>Progress</span>
                    <span>Target: {stat.target}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className={`h-2 rounded-full transition-all duration-1000 ${
                        stat.color === 'blue' ? 'bg-gradient-to-r from-blue-400 to-blue-600' :
                        stat.color === 'green' ? 'bg-gradient-to-r from-emerald-400 to-green-600' :
                        stat.color === 'orange' ? 'bg-gradient-to-r from-amber-400 to-orange-600' :
                        'bg-gradient-to-r from-purple-400 to-pink-600'
                      }`}
                      style={{ width: `${Math.min(progressPercentage, 100)}%` }}
                    ></div>
                  </div>
                  <div className="text-xs text-gray-500 font-medium">
                    {Math.round(progressPercentage)}% of target achieved
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Enhanced Full Width Analytics Chart */}
      <div className="mb-14">
        <div className="bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-10 border border-white/50">
          <div className="flex items-center justify-between mb-10">
            <div className="flex items-center gap-4">
              <div className="p-4 bg-gradient-to-br from-indigo-500 via-purple-600 to-pink-600 rounded-2xl shadow-xl">
                <PieChartIcon className="w-7 h-7 text-white" />
              </div>
              <div>
                <h2 className="text-4xl font-black text-gray-800 mb-2">Most Purchased Items Analysis</h2>
                <p className="text-gray-600 font-semibold text-lg">Comprehensive insights into top-performing products and trends</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl border border-indigo-200">
                <span className="text-sm font-bold text-indigo-800">Last 30 Days Performance</span>
              </div>
              <button className="p-3 bg-gray-100 hover:bg-gray-200 rounded-2xl transition-colors">
                <Download className="w-5 h-5 text-gray-600" />
              </button>
            </div>
          </div>
          <div className="h-[28rem]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart 
                data={mostPurchasedItems}
                margin={{ top: 40, right: 60, left: 60, bottom: 140 }}
              >
                <CartesianGrid strokeDasharray="4 4" stroke="#e2e8f0" strokeOpacity={0.6} />
                <XAxis 
                  dataKey="item" 
                  stroke="#64748b" 
                  angle={-45}
                  textAnchor="end"
                  height={140}
                  fontSize={14}
                  interval={0}
                  tick={{ fontSize: 14, fontWeight: 700 }}
                />
                <YAxis stroke="#64748b" fontSize={14} fontWeight={700} />
                <Tooltip content={<CustomTooltip />} />
                <Bar 
                  dataKey="value" 
                  fill="url(#enhancedItemsGradient)" 
                  radius={[12, 12, 0, 0]}
                  maxBarSize={120}
                />
                <defs>
                  <linearGradient id="enhancedItemsGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#6366F1" stopOpacity={1}/>
                    <stop offset="25%" stopColor="#8B5CF6" stopOpacity={0.95}/>
                    <stop offset="75%" stopColor="#D946EF" stopOpacity={0.9}/>
                    <stop offset="100%" stopColor="#F97316" stopOpacity={0.85}/>
                  </linearGradient>
                </defs>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Enhanced Main Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-12">
        {/* Left Column */}
        <div className="xl:col-span-2 space-y-12">
          {/* Premium Purchase Analytics */}
          <div className="bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-10 border border-white/50">
            <div className="flex items-center justify-between mb-10">
              <div className="flex items-center gap-4">
                <div className="p-4 bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-600 rounded-2xl shadow-xl">
                  <Activity className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h2 className="text-4xl font-black text-gray-800 mb-2">Purchase Analytics</h2>
                  <p className="text-gray-600 font-semibold text-lg">Multi-branch performance tracking and insights</p>
                </div>
              </div>
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-4 text-sm">
                  <div className="flex items-center gap-3 px-6 py-3 bg-blue-100 rounded-2xl border border-blue-200 shadow-sm">
                    <div className="w-4 h-4 rounded-full bg-blue-500 shadow-sm"></div>
                    <span className="text-blue-800 font-black">HEAD-OFFICE</span>
                  </div>
                  <div className="flex items-center gap-3 px-6 py-3 bg-amber-100 rounded-2xl border border-amber-200 shadow-sm">
                    <div className="w-4 h-4 rounded-full bg-amber-500 shadow-sm"></div>
                    <span className="text-amber-800 font-black">HILARA</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-96">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={purchaseSummaryData}>
                  <defs>
                    <linearGradient id="enhancedHeadOfficeGradient" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.6}/>
                      <stop offset="95%" stopColor="#3B82F6" stopOpacity={0.1}/>
                    </linearGradient>
                    <linearGradient id="enhancedHilaraGradient" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.6}/>
                      <stop offset="95%" stopColor="#F59E0B" stopOpacity={0.1}/>
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="4 4" stroke="#e2e8f0" strokeOpacity={0.6} />
                  <XAxis dataKey="month" stroke="#64748b" fontSize={14} fontWeight={700} />
                  <YAxis stroke="#64748b" fontSize={14} fontWeight={700} />
                  <Tooltip content={<CustomTooltip />} />
                  <Area 
                    type="monotone" 
                    dataKey="HEAD-OFFICE" 
                    stroke="#3B82F6" 
                    strokeWidth={5}
                    fill="url(#enhancedHeadOfficeGradient)"
                    dot={{ fill: '#3B82F6', strokeWidth: 3, r: 10 }}
                    activeDot={{ r: 12, fill: '#3B82F6', strokeWidth: 4, stroke: '#fff' }}
                  />
                  <Area 
                    type="monotone" 
                    dataKey="HILARA" 
                    stroke="#F59E0B" 
                    strokeWidth={5}
                    fill="url(#enhancedHilaraGradient)"
                    dot={{ fill: '#F59E0B', strokeWidth: 3, r: 10 }}
                    activeDot={{ r: 12, fill: '#F59E0B', strokeWidth: 4, stroke: '#fff' }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Enhanced Integrated Fleet & Inventory */}
          <div className="bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-10 border border-white/50">
            <div className="flex items-center justify-between mb-10">
              <div className="flex items-center gap-4">
                <div className="p-4 bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-600 rounded-2xl shadow-xl">
                  <Settings className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-3xl font-black text-gray-800 mb-2">Fleet & Inventory Management</h3>
                  <p className="text-gray-600 font-semibold">Real-time vehicle monitoring with comprehensive inventory analysis</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Enhanced Vehicle Selection */}
              <div className="space-y-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-3 h-10 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full shadow-lg"></div>
                  <h4 className="text-2xl font-black text-gray-800">Vehicle Selection</h4>
                </div>
                
                <select 
                  value={selectedVehicle}
                  onChange={(e) => setSelectedVehicle(e.target.value)}
                  className="w-full px-8 py-5 border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/30 focus:border-blue-500 bg-white/80 backdrop-blur-sm shadow-lg hover:bg-white transition-all font-semibold text-gray-700 text-lg"
                >
                  <option value="">Choose a vehicle...</option>
                  {vehicles.map(vehicle => (
                    <option key={vehicle.id} value={vehicle.id}>{vehicle.name}</option>
                  ))}
                </select>

                {selectedVehicle && (
                  <div className="space-y-6">
                    <div className="p-8 bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-100 rounded-2xl border-2 border-blue-200 shadow-lg">
                      {(() => {
                        const vehicle = vehicles.find(v => v.id === selectedVehicle);
                        return (
                          <div className="space-y-6">
                            <div className="flex items-center justify-between p-4 bg-white/80 rounded-xl shadow-sm">
                              <span className="text-sm font-black text-blue-800">Vehicle Status</span>
                              <span className={`px-5 py-2 rounded-full text-sm font-black shadow-sm ${
                                vehicle?.status === 'Active' 
                                  ? 'bg-emerald-100 text-emerald-800 border-2 border-emerald-200' 
                                  : 'bg-red-100 text-red-800 border-2 border-red-200'
                              }`}>
                                {vehicle?.status}
                              </span>
                            </div>
                            
                            <div className="flex items-center justify-between p-4 bg-white/80 rounded-xl shadow-sm">
                              <span className="text-sm font-black text-blue-800">Driver Assigned</span>
                              <span className="text-sm text-blue-700 font-bold bg-blue-100 px-4 py-2 rounded-lg shadow-sm">
                                {vehicle?.driver}
                              </span>
                            </div>
                            
                            <div className="flex items-center justify-between p-4 bg-white/80 rounded-xl shadow-sm">
                              <span className="text-sm font-black text-blue-800">Current Location</span>
                              <span className="text-sm text-blue-700 font-bold bg-blue-100 px-4 py-2 rounded-lg shadow-sm">
                                {vehicle?.location}
                              </span>
                            </div>
                            
                            <div className="flex items-center justify-between p-4 bg-white/80 rounded-xl shadow-sm">
                              <span className="text-sm font-black text-blue-800">Last Maintenance</span>
                              <span className="text-sm text-blue-700 font-bold bg-blue-100 px-4 py-2 rounded-lg shadow-sm">
                                {vehicle?.maintenance}
                              </span>
                            </div>
                            
                            <div className="p-4 bg-white/80 rounded-xl shadow-sm">
                              <div className="flex items-center justify-between mb-3">
                                <span className="text-sm font-black text-blue-800">Fuel Level</span>
                                <span className="text-sm text-blue-700 font-black">{vehicle?.fuel}</span>
                              </div>
                              <div className="w-full bg-gray-200 rounded-full h-3 shadow-inner">
                                <div 
                                  className="bg-gradient-to-r from-green-400 via-green-500 to-green-600 h-3 rounded-full transition-all duration-1000 shadow-lg" 
                                  style={{ width: vehicle?.fuel }}
                                ></div>
                              </div>
                              <div className="flex justify-between text-xs mt-2 font-medium text-gray-600">
                                <span>Empty</span>
                                <span>Full</span>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                )}
              </div>

              {/* Enhanced Dynamic Inventory Chart */}
              <div className="space-y-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-3 h-10 bg-gradient-to-b from-amber-500 to-orange-600 rounded-full shadow-lg"></div>
                  <h4 className="text-2xl font-black text-gray-800">
                    {selectedVehicle 
                      ? `Inventory for ${vehicles.find(v => v.id === selectedVehicle)?.name.split(' - ')[0]}` 
                      : 'Overall Inventory Distribution'
                    }
                  </h4>
                </div>

                <div className="h-80 flex items-center justify-center bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 rounded-2xl border-2 border-gray-200 shadow-lg p-6">
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={selectedVehicle ? [
                          { name: 'Engine Parts', value: 45, color: '#3B82F6', description: 'Critical components' },
                          { name: 'Safety Equipment', value: 30, color: '#F59E0B', description: 'Safety systems' },
                          { name: 'Maintenance Tools', value: 25, color: '#10B981', description: 'Service equipment' }
                        ] : pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={110}
                        dataKey="value"
                        stroke="#fff"
                        strokeWidth={5}
                      >
                        {(selectedVehicle ? [
                          { name: 'Engine Parts', value: 45, color: '#3B82F6' },
                          { name: 'Safety Equipment', value: 30, color: '#F59E0B' },
                          { name: 'Maintenance Tools', value: 25, color: '#10B981' }
                        ] : pieData).map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  {(selectedVehicle ? [
                    { name: 'Engine Parts', value: 45, color: '#3B82F6', description: 'Critical components' },
                    { name: 'Safety Equipment', value: 30, color: '#F59E0B', description: 'Safety systems' },
                    { name: 'Maintenance Tools', value: 25, color: '#10B981', description: 'Service equipment' }
                  ] : pieData).map((entry, index) => (
                    <div key={index} className="flex items-center justify-between p-5 bg-white rounded-2xl border-2 border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300">
                      <div className="flex items-center gap-4">
                        <div className="w-6 h-6 rounded-full shadow-lg border-2 border-white" style={{ backgroundColor: entry.color }}></div>
                        <div>
                          <span className="text-base text-gray-800 font-black">{entry.name}</span>
                          <p className="text-xs text-gray-500 font-medium">{entry.description}</p>
                        </div>
                      </div>
                      <span className="text-lg font-black text-gray-900">{entry.value}%</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Right Column */}
        <div className="space-y-12">
          {/* Premium Branch Performance */}
          <div className="bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-10 border border-white/50">
            <div className="flex items-center gap-4 mb-10">
              <div className="p-4 bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl shadow-xl">
                <Target className="w-7 h-7 text-white" />
              </div>
              <div>
                <h2 className="text-3xl font-black text-gray-800 mb-2">Branch Performance</h2>
                <p className="text-gray-600 font-semibold">Revenue comparison & growth analysis</p>
              </div>
            </div>
            
            <div className="space-y-8">
              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={topPurchasedData} layout="horizontal">
                    <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                    <XAxis type="number" stroke="#64748b" fontSize={13} fontWeight={700} />
                    <YAxis dataKey="name" type="category" stroke="#64748b" fontSize={13} fontWeight={700} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar 
                      dataKey="value" 
                      fill="url(#enhancedBranchGradient)" 
                      radius={[0, 15, 15, 0]}
                    />
                    <defs>
                      <linearGradient id="enhancedBranchGradient" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor="#10B981" stopOpacity={0.8}/>
                        <stop offset="50%" stopColor="#059669" stopOpacity={0.9}/>
                        <stop offset="100%" stopColor="#047857" stopOpacity={1}/>
                      </linearGradient>
                    </defs>
                  </BarChart>
                </ResponsiveContainer>
              </div>
              
              {/* Branch Details */}
              <div className="grid grid-cols-1 gap-4">
                {topPurchasedData.map((branch, index) => (
                  <div key={index} className="p-6 bg-gradient-to-r from-emerald-50 to-green-50 rounded-2xl border-2 border-emerald-200 shadow-lg">
                    <div className="flex items-center justify-between mb-3">
                      <h4 className="text-lg font-black text-emerald-800">{branch.name}</h4>
                      <span className="text-sm font-bold text-emerald-600 bg-emerald-100 px-3 py-1 rounded-lg">
                        +{branch.growth}%
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-2xl font-black text-gray-800">₹{branch.value.toLocaleString()}</span>
                      <span className="text-sm font-medium text-gray-600">{branch.percentage}% of total</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Enhanced Horizontal Action Center */}
          <div className="bg-white/85 backdrop-blur-3xl rounded-3xl shadow-2xl p-10 border border-white/50">
            <div className="flex items-center justify-between mb-10">
              <div className="flex items-center gap-4">
                <div className="p-4 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl shadow-xl">
                  <Zap className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h2 className="text-3xl font-black text-gray-800 mb-2">Action Center</h2>
                  <p className="text-gray-600 font-semibold">Priority-based task management system</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-4xl font-black text-purple-600 mb-1">
                  {pendingItems.reduce((sum, item) => sum + item.count, 0)}
                </div>
                <div className="text-sm text-gray-500 font-bold uppercase tracking-wide">Total Tasks</div>
              </div>
            </div>

            {/* Navigation and Current Item Display */}
            <div className="relative">
              {/* Navigation Controls */}
              <div className="flex items-center justify-between mb-8">
                <button 
                  onClick={prevAction}
                  className="p-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-2xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 shadow-xl hover:shadow-2xl flex items-center gap-3 font-bold group hover:-translate-y-1"
                >
                  <ChevronLeft className="w-6 h-6 group-hover:scale-110 transition-transform" />
                  Previous
                </button>

                <div className="flex items-center gap-4">
                  <div className="text-lg font-black text-gray-700">
                    {currentActionIndex + 1} of {pendingItems.length}
                  </div>
                  {/* Pagination Dots */}
                  <div className="flex items-center gap-2">
                    {pendingItems.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentActionIndex(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          index === currentActionIndex 
                            ? 'bg-purple-600 scale-125 shadow-lg' 
                            : 'bg-gray-300 hover:bg-gray-400'
                        }`}
                      />
                    ))}
                  </div>
                </div>

                <button 
                  onClick={nextAction}
                  className="p-4 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-2xl hover:from-purple-600 hover:to-pink-700 transition-all duration-300 shadow-xl hover:shadow-2xl flex items-center gap-3 font-bold group hover:-translate-y-1"
                >
                  Next
                  <ChevronRight className="w-6 h-6 group-hover:scale-110 transition-transform" />
                </button>
              </div>

              {/* Current Action Item */}
              <div className="relative overflow-hidden">
                <div 
                  className="flex transition-transform duration-500 ease-in-out"
                  style={{ transform: `translateX(-${currentActionIndex * 100}%)` }}
                >
                  {pendingItems.map((item, index) => (
                    <div key={index} className="w-full flex-shrink-0">
                      <div className={`group relative bg-gradient-to-r ${item.bgColor} p-8 rounded-3xl border-2 ${item.borderColor} hover:shadow-2xl transition-all duration-500 hover:-translate-y-2`}>
                        <div className="flex flex-col lg:flex-row gap-6">
                          {/* Icon Section */}
                          <div className={`w-24 h-24 rounded-3xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300 flex-shrink-0`}>
                            <FileText className="w-12 h-12 text-white" />
                          </div>
                          
                          {/* Content Section */}
                          <div className="flex-1 min-w-0">
                            <div className="flex flex-col md:flex-row md:items-center gap-4 mb-4">
                              <div className="text-5xl font-black text-gray-800">{item.count}</div>
                              <div className={`px-6 py-3 rounded-full text-lg font-black ${
                                item.priority === 'high' ? 'bg-red-100 text-red-800 border-2 border-red-200' :
                                item.priority === 'medium' ? 'bg-yellow-100 text-yellow-800 border-2 border-yellow-200' :
                                'bg-green-100 text-green-800 border-2 border-green-200'
                              }`}>
                                {item.priority.toUpperCase()} PRIORITY
                              </div>
                            </div>
                            
                            <h3 className="text-2xl text-gray-800 font-black mb-4 truncate">{item.type}</h3>
                            
                            {/* Vehicle Details - Compact Layout */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></div>
                                <span className="text-sm sm:text-base text-gray-600 font-medium truncate">Due: {item.dueDate}</span>
                              </div>
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
                                <span className="text-sm sm:text-base text-gray-600 font-medium truncate">Dept: {item.department}</span>
                              </div>
                              {selectedVehicle && (
                                <>
                                  <div className="flex items-center gap-2">
                                    <div className="w-2 h-2 bg-purple-500 rounded-full flex-shrink-0"></div>
                                    <span className="text-sm sm:text-base text-gray-600 font-medium truncate">
                                      Vehicle: {vehicles.find(v => v.id === selectedVehicle)?.name.split(' - ')[0]}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="w-2 h-2 bg-amber-500 rounded-full flex-shrink-0"></div>
                                    <span className="text-sm sm:text-base text-gray-600 font-medium truncate">
                                      Status: {vehicles.find(v => v.id === selectedVehicle)?.status}
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div className="flex flex-col items-end gap-6 lg:ml-auto">
                            <button className="px-6 py-4 bg-white/90 backdrop-blur-sm text-blue-600 hover:text-blue-700 text-base font-black rounded-2xl flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-all duration-300 border-2 border-blue-200 hover:bg-blue-50 shadow-lg hover:shadow-xl hover:-translate-y-1 whitespace-nowrap">
                              <Eye className="w-5 h-5" />
                              View Details
                            </button>
                            
                            {item.priority === 'high' && (
                              <div className="flex items-center gap-2 text-sm font-black text-red-600 whitespace-nowrap">
                                <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse shadow"></div>
                                URGENT ACTION
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Enhanced progress indicator for high priority items */}
                        {item.priority === 'high' && (
                          <div className="mt-6 pt-6 border-t-2 border-orange-200">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                              <span className="font-black text-orange-800">Urgency Level Assessment</span>
                              <span className="font-black text-red-700 bg-red-100 px-4 py-2 rounded-xl border border-red-200 text-sm sm:text-base">
                                CRITICAL STATUS
                              </span>
                            </div>
                            <div className="w-full bg-orange-200 rounded-full h-4 shadow-inner">
                              <div className="bg-gradient-to-r from-red-500 via-orange-500 to-red-600 h-4 rounded-full animate-pulse shadow-lg" style={{ width: '85%' }}></div>
                            </div>
                            <div className="flex justify-between text-sm mt-2 font-bold text-orange-700">
                              <span>0%</span>
                              <span className="text-red-700">85% Critical</span>
                              <span>100%</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Enhanced Summary Dashboard */}
            <div className="mt-12 p-8 bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 rounded-3xl border-2 border-indigo-200 shadow-xl">
              <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-4">
                  <div className="p-4 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl shadow-lg">
                    <Activity className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <div className="text-xl font-black text-gray-800">Performance Dashboard</div>
                    <div className="text-sm text-gray-600 font-medium">Comprehensive departmental overview</div>
                  </div>
                </div>
                <div className="flex flex-wrap justify-center gap-6">
                  <div className="text-center">
                    <div className="text-2xl font-black text-red-600">
                      {pendingItems.filter(item => item.priority === 'high').reduce((sum, item) => sum + item.count, 0)}
                    </div>
                    <div className="text-xs text-red-500 font-bold uppercase">High Priority</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-black text-yellow-600">
                      {pendingItems.filter(item => item.priority === 'medium').reduce((sum, item) => sum + item.count, 0)}
                    </div>
                    <div className="text-xs text-yellow-500 font-bold uppercase">Medium Priority</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-black text-green-600">
                      {pendingItems.filter(item => item.priority === 'low').reduce((sum, item) => sum + item.count, 0)}
                    </div>
                    <div className="text-xs text-green-500 font-bold uppercase">Low Priority</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Premium Footer Stats */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-white/70 backdrop-blur-2xl rounded-2xl p-8 border border-white/50 text-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
          <div className="text-4xl font-black text-gray-800 mb-3">98.5%</div>
          <div className="text-sm font-black text-gray-600 uppercase tracking-wider">System Uptime</div>
          <div className="text-xs text-green-600 font-semibold mt-2">Excellent Performance</div>
        </div>
        <div className="bg-white/70 backdrop-blur-2xl rounded-2xl p-8 border border-white/50 text-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
          <div className="text-4xl font-black text-gray-800 mb-3">2.4s</div>
          <div className="text-sm font-black text-gray-600 uppercase tracking-wider">Avg Response Time</div>
          <div className="text-xs text-blue-600 font-semibold mt-2">Optimal Speed</div>
        </div>
        <div className="bg-white/70 backdrop-blur-2xl rounded-2xl p-8 border border-white/50 text-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
          <div className="text-4xl font-black text-gray-800 mb-3">1,247</div>
          <div className="text-sm font-black text-gray-600 uppercase tracking-wider">Active Users</div>
          <div className="text-xs text-purple-600 font-semibold mt-2">High Engagement</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;